import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { validateAndDecodeAuthToken } from '../utils/helper';
import { AuthenticatedWrapperProps, AuthTokenResponse } from './service.type';
import { WebSocketProvider } from './context/websocketContext';
import { useAuth } from './context/authContext';

export const AuthenticatedWrapper: FC<AuthenticatedWrapperProps> = (props) => {
  const validAuthToken: AuthTokenResponse | null = validateAndDecodeAuthToken();
  const { accessToken } = useAuth();

  if (!validAuthToken) {
    return <Navigate to="/login" replace />;
  }

  if (props.restrictedToUserTypes?.includes(validAuthToken.type)) {
    return <Navigate to="*" replace />;
  }

  return (
    <WebSocketProvider
      url={
        `${
          process.env.REACT_APP_WEBSOCKET_URL +
            '?Authorization=' +
            accessToken || ''
        }` || ''
      }
      heartbeatIntervalMs={Number(
        process.env.REACT_APP_WEBSOCKET_HEARTBEAT_INTERVAL || 12000,
      )}
    >
      {props.children}
    </WebSocketProvider>
  );
};
